<ng-container *ngIf="facets$ | async as facets">
  <div data-cy="cms-facet-list"
       class="mb-facet-list"
  >
    <div class="inner ng-star-inserted">
      <ng-container *ngFor="let facet of facets">
        <mb-cms-facet *ngIf="facet?.counts?.length"
                      [facetCategory]="facet"
                      [currentFilter]="currentFilter"
                      class="multi-select"
                      [jobs]="jobs"
        ></mb-cms-facet>
      </ng-container>
    </div>
  </div>
</ng-container>
